import React from 'react';

function Iframe({ size, stroke, strokeWidth, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={stroke}
      strokeWidth={strokeWidth}
      {...otherProps}
    >
      <path
        d="M10,10 L6.5,6.5"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10,10 L10,7"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10,10 L7,10"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect stroke={stroke} strokeWidth={strokeWidth} x="11" y="11" width="9" height="9" rx="2" />
      <path
        d="M9.51606054,19 C7.49622525,18.9837122 6.1828775,18.9755682 5.5760173,18.9755682 C4.66572699,18.9755682 4,18.3156048 4,17.3995509 C4,16.4834971 4,6.4922997 4,5.57942121 C4,4.66654272 4.66205664,4.00247866 5.5760173,4.00247866 C6.48997795,4.00247866 16.4821864,4.00247866 17.396147,4.00247866 C18.3101077,4.00247866 18.9701796,4.66690345 18.9701796,5.57942121 C18.9701796,6.18776639 18.9701796,7.50111414 18.9701796,9.51946445"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

export default Iframe;
